/** Instance refresh cues share the authenticated transport, independently of analytics. */

import type { HomeLiveTick } from '@/types/home'
import { WebSocketClient } from '../client'
import { SubscriptionRegistry } from '../subscriptions'

export class HomeLiveApi {
  private readonly ticks: SubscriptionRegistry<null, HomeLiveTick>

  constructor(
    private readonly client: Pick<
      WebSocketClient,
      'attachOnce' | 'emitWhenConnected'
    >
  ) {
    this.ticks = new SubscriptionRegistry({
      join: () => this.client.emitWhenConnected('subscribe_home_live', {}),
      leave: () => this.client.emitWhenConnected('unsubscribe_home_live', {}),
    })
  }

  subscribe(callback: (tick: HomeLiveTick) => void): () => void {
    this.attachHandler()
    return this.ticks.subscribe(null, callback)
  }

  private attachHandler(): void {
    this.client.attachOnce('home_live_tick', (raw) =>
      this.ticks.dispatch(null, raw as HomeLiveTick)
    )
  }

  replay(): void {
    this.attachHandler()
    this.ticks.replay()
  }

  clear(): void {
    this.ticks.clear()
  }
}
